'use client'

import { usePathname } from 'next/navigation'
import Script from 'next/script'
import { FC } from 'react'

import { stripLocaleFromPathname } from '../../../../lib/routing'
import { useConsentPolicy } from '../../../_providers/ConsentPolicyProvider.client'

// Paths for FriendBuy referrals; we need to load the SDK eagerly regardless of consent.
const FRIENDBUY_REFERRAL_PATHS = new Set([
  // US campaigns
  '/pages/refer',
  '/pages/friend',
  // INTL campaigns
  '/pages/refer-adv',
  '/pages/refer-friend',
])

export const FriendBuyScript: FC = () => {
  const {
    consentPolicy: { functional },
  } = useConsentPolicy()
  const pathname = usePathname()
  const strippedPathname = stripLocaleFromPathname(pathname ?? '/')
  const isReferralPage = FRIENDBUY_REFERRAL_PATHS.has(strippedPathname)
  const fetchPriority = isReferralPage ? 'high' : 'auto'
  const scriptLoadingStrategy = fetchPriority === 'high' ? 'beforeInteractive' : 'lazyOnload' // Marketing is set to lazy on load

  if (functional !== 'allowed' && !isReferralPage) return null

  return (
    <Script
      id='friendbuy-script'
      strategy={scriptLoadingStrategy}
      dangerouslySetInnerHTML={{
        __html: `
          if (window.friendbuyAPI?.loaded !== true) {
            window["friendbuyAPI"] = friendbuyAPI = window["friendbuyAPI"] || [];

            shopifyCustomer = friendbuyAPI?.shopify?.customer

            if (!shopifyCustomer) {
              friendbuyAPI.privateMode = true;
            }
        
            // registers your merchant using your merchant ID found in the
            // retailer app https://retailer.friendbuy.io/settings/general
            friendbuyAPI.merchantId = "55773582-8d2f-4f00-9a3a-559bee7b2831";
            
        
            // load the merchant SDK and your campaigns
            (function(f, r, n, d, b, u, y) {
              while ((u = n.shift())) {
                (b = f.createElement(r)), (y = f.getElementsByTagName(r)[0]);
                b.async = 1;
                b.src = u;
                b.fetchPriority = '${fetchPriority}';
                y.parentNode.insertBefore(b, y);
              }
            })(document, "script", [
              "https://static.fbot.me/friendbuy.js",
              "https://campaign.fbot.me/" + friendbuyAPI.merchantId + "/campaigns.js",
            ]);

            friendbuyAPI.push(["merchant", friendbuyAPI.merchantId]);
            friendbuyAPI.push(["url", window.location.href]);
            
            if (shopifyCustomer && shopifyCustomer.id && shopifyCustomer.email) {
              if (shopifyCustomer.firstName && shopifyCustomer.lastName) {
                shopifyCustomer.name = shopifyCustomer.firstName + " " + shopifyCustomer.lastName;
              }
              friendbuyAPI.push([
                "auth",
                friendbuyAPI.shopify.authMessage,
                friendbuyAPI.shopify.authSignature,
              ]);
              friendbuyAPI.push(["track", "customer", shopifyCustomer, true]);
            }
          }
        `,
      }}
    />
  )
}
